export default "__VITE_ASSET__f3752fc3__"